import React, { createContext, useContext } from 'react';

interface Component {
  onError?: ((error: string) => void) | undefined;
  onClose: () => void;
}

export interface RegisteredPanel {
  id: string;
  label: string;
  component: (props: Component) => JSX.Element;
}

const DebugPanelContext = createContext<RegisteredPanel[]>([]);

export const DebugPanelProvider: React.FC<
  React.PropsWithChildren<{ panels: RegisteredPanel[] }>
> = ({ panels, children }) => (
  <DebugPanelContext.Provider value={panels}>
    {children}
  </DebugPanelContext.Provider>
);

export const usePanels = (): RegisteredPanel[] => useContext(DebugPanelContext);
